import React, { useState, useEffect } from 'react';
import { createCharacter, regenerateAvatar } from './api';
import CreatingLoader from './CreatingLoader';
import './CharacterCreator.css';

const HAIR_OPTIONS = ['brunette', 'brown', 'blonde', 'red'];
const EYE_OPTIONS = ['blue', 'green', 'brown', 'hazel', 'gray', 'dark'];

const TITS_OPTIONS = ['small', 'medium', 'big', 'huge'];
const ASS_OPTIONS = ['small', 'medium', 'big', 'huge'];

const TITS_IMAGES = {
  small: '/smallT.jpeg',
  medium: '/mediumT.jpeg',
  big: '/bigT.jpeg',
  huge: '/hugeT.jpeg',
};

const ASS_IMAGES = {
  small: '/smallA.jpeg',
  medium: '/mediumA.jpeg',
  big: '/bigA.jpeg',
  huge: '/hugeA.jpeg',
};

const HAIR_IMAGES = {
  'brunette': '/blackhair.jpeg',
  'brown': '/brownhair.jpeg',
  'blonde': '/platinumhair.jpg',
  'red': '/redhair.jpeg',
};

const FANTASY_OPTIONS = [
  { id: 'threesome', label: 'Threesome' },
  { id: 'backdoor', label: 'Backdoor action' },
  { id: 'bdsm', label: 'BDSM' },
  { id: 'roleplay', label: 'Roleplay' },
  { id: 'age-gap', label: 'Age Gap' },
  { id: 'domination', label: 'Domination' },
  { id: 'voyeurism', label: 'Voyeurism' },
  { id: 'outdoor', label: 'Outdoor / Public' },
];

const TOTAL_STEPS = 6;

function CharacterCreator({ onCreated, onClose, guestMode = false }) {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [createdChar, setCreatedChar] = useState(null);
  const [error, setError] = useState('');

  // Step 1 - Identity
  const [name, setName] = useState('');
  const [age, setAge] = useState(24);

  // Step 2 - Body
  const [tits, setTits] = useState('medium');
  const [ass, setAss] = useState('medium');

  // Step 3 - Hair & Eyes
  const [hair, setHair] = useState('brunette');
  const [eyes, setEyes] = useState('blue');

  // Step 4 - Spicy photos
  const [wantsSpicyPhotos, setWantsSpicyPhotos] = useState(null);

  // Step 5 - Fantasies
  const [fantasies, setFantasies] = useState([]);

  // Step 6 - Personality sliders
  const [libido, setLibido] = useState(7);
  const [kinkiness, setKinkiness] = useState(6);
  const [boldness, setBoldness] = useState(7);

  // Step 7 - Voice messages (coming soon)

  const toggleFantasy = (id) => {
    setFantasies(prev =>
      prev.includes(id) ? prev.filter(f => f !== id) : [...prev, id]
    );
  };

  const buildVisualPrompt = () => {
    const titsDesc = tits === 'huge' ? 'huge breasts' : tits === 'big' ? 'big breasts' : tits === 'medium' ? 'medium breasts' : 'small breasts';
    const assDesc = ass === 'huge' ? 'huge butt' : ass === 'big' ? 'big butt' : ass === 'medium' ? 'medium butt' : 'small butt';
    return `${hair} hair, ${eyes} eyes, ${titsDesc}, ${assDesc}`;
  };

  const buildDescription = () => {
    const boldDesc = boldness >= 8 ? 'very bold and assertive' : boldness >= 5 ? 'confident' : 'shy and sweet';
    const kinkyDesc = kinkiness >= 8 ? 'very kinky and explicit' : kinkiness >= 5 ? 'adventurous and playful' : 'romantic and sensual';
    const libidoDesc = libido >= 8 ? 'extremely high sex drive' : libido >= 5 ? 'high libido' : 'moderate libido';
    const spicyDesc = wantsSpicyPhotos ? 'loves sending spicy and provocative photos' : 'prefers keeping things classy';
    return `${boldDesc}, ${kinkyDesc}, ${libidoDesc}, ${spicyDesc}, flirty from the start, direct and authentic in conversation`;
  };

  const handleCreate = async () => {
    setError('');

    if (guestMode) {
      onCreated({
        name,
        age,
        description: buildDescription(),
        visual_prompt: buildVisualPrompt(),
      });
      return;
    }

    setLoading(true);
    try {
      const res = await createCharacter({
        name,
        age,
        description: buildDescription(),
        visual_prompt: buildVisualPrompt(),
      });
      setCreatedChar(res.data);
      setShowLoader(true);
      if (window.fbq) window.fbq('track', 'Lead', { content_name: name });
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to create character.');
    } finally {
      setLoading(false);
    }
  };

  const progressPercent = ((step - 1) / (TOTAL_STEPS - 1)) * 100;

  // Poll for avatar if it came back null
  useEffect(() => {
    if (!showLoader || !createdChar || createdChar.avatar_url) return;
    let cancelled = false;
    const tryRegen = async () => {
      for (let i = 0; i < 3; i++) {
        if (cancelled) return;
        try {
          const res = await regenerateAvatar(createdChar.id);
          if (!cancelled && res.data?.avatar_url) {
            setCreatedChar(prev => ({ ...prev, avatar_url: res.data.avatar_url }));
            return;
          }
        } catch {}
        await new Promise(r => setTimeout(r, 3000));
      }
    };
    tryRegen();
    return () => { cancelled = true; };
  }, [showLoader, createdChar?.id, createdChar?.avatar_url]);

  if (showLoader && createdChar) {
    return (
      <CreatingLoader
        avatarUrl={createdChar.avatar_url || null}
        charName={name}
        onDone={() => {
          setShowLoader(false);
          onCreated(createdChar);
        }}
      />
    );
  }

  const canContinue = () => {
    if (step === 1) return name.trim().length > 0;
    if (step === 4) return wantsSpicyPhotos !== null;
    return true;
  };

  return (
    <div className="overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal creator-modal">
        <button className="modal-close" onClick={onClose}>&#x2715;</button>
        <h2 className="modal-title">Create your perfect girlfriend</h2>

        {/* Progress bar */}
        <div className="creator-progress">
          <div className="creator-progress-bar" style={{ width: `${progressPercent}%` }} />
        </div>

        {/* Step 1 - Name & Age */}
        {step === 1 && (
          <div className="step-body">
            <div className="form-field">
              <label>Her name</label>
              <input
                type="text"
                placeholder="e.g. Sofia, Luna, Mia..."
                value={name}
                onChange={(e) => setName(e.target.value)}
                autoFocus
              />
            </div>

            <div className="form-field">
              <label>Age: <span className="range-val">{age}</span></label>
              <input
                type="range"
                min="18"
                max="35"
                value={age}
                onChange={(e) => setAge(parseInt(e.target.value))}
              />
              <div className="range-labels"><span>18</span><span>35</span></div>
            </div>

            <div className="step-nav">
              <button className="btn-primary" onClick={() => setStep(2)} disabled={!canContinue()}>
                Continue
              </button>
            </div>
          </div>
        )}

        {/* Step 2 - Body (Tits & Ass) */}
        {step === 2 && (
          <div className="step-body">
            <div className="form-field">
              <label>Tits</label>
              <div className="options-grid body-grid">
                {TITS_OPTIONS.map(o => (
                  <button key={o} className={`opt-btn has-img ${tits === o ? 'selected' : ''}`} onClick={() => setTits(o)}>
                    <img src={TITS_IMAGES[o]} alt={o} className="opt-img" />
                    <span className="opt-label">{o}</span>
                  </button>
                ))}
              </div>
            </div>

            <div className="form-field">
              <label>Ass</label>
              <div className="options-grid body-grid">
                {ASS_OPTIONS.map(o => (
                  <button key={o} className={`opt-btn has-img ${ass === o ? 'selected' : ''}`} onClick={() => setAss(o)}>
                    <img src={ASS_IMAGES[o]} alt={o} className="opt-img" />
                    <span className="opt-label">{o}</span>
                  </button>
                ))}
              </div>
            </div>

            <div className="step-nav">
              <button className="btn-ghost" onClick={() => setStep(1)}>Back</button>
              <button className="btn-primary" onClick={() => setStep(3)}>Continue</button>
            </div>
          </div>
        )}

        {/* Step 3 - Hair & Eyes */}
        {step === 3 && (
          <div className="step-body">
            <div className="form-field">
              <label>Hair color</label>
              <div className="options-grid hair-grid">
                {HAIR_OPTIONS.map(o => (
                  <button key={o} className={`opt-btn has-img ${hair === o ? 'selected' : ''}`} onClick={() => setHair(o)}>
                    <img src={HAIR_IMAGES[o]} alt={o} className="opt-img" />
                    <span className="opt-label">{o}</span>
                  </button>
                ))}
              </div>
            </div>

            <div className="form-field">
              <label>Eye color</label>
              <div className="options-grid cols-3">
                {EYE_OPTIONS.map(o => (
                  <button key={o} className={`opt-btn ${eyes === o ? 'selected' : ''}`} onClick={() => setEyes(o)}>{o}</button>
                ))}
              </div>
            </div>

            <div className="step-nav">
              <button className="btn-ghost" onClick={() => setStep(2)}>Back</button>
              <button className="btn-primary" onClick={() => setStep(4)}>Continue</button>
            </div>
          </div>
        )}

        {/* Step 4 - Spicy Photos */}
        {step === 4 && (
          <div className="step-body">
            <div className="spicy-question">
              <div className="spicy-emoji">🔥📸</div>
              <h3 className="spicy-title">Would you like to receive spicy photos? 🌶️</h3>
              <p className="spicy-subtitle">She can send you exclusive photos during your conversations 💋</p>

              <div className="spicy-options">
                <button
                  className={`spicy-btn ${wantsSpicyPhotos === true ? 'selected yes' : ''}`}
                  onClick={() => setWantsSpicyPhotos(true)}
                >
                  <span className="spicy-btn-emoji">💦</span>
                  <span className="spicy-btn-text">Yes, absolutely!</span>
                </button>
                <button
                  className={`spicy-btn ${wantsSpicyPhotos === false ? 'selected no' : ''}`}
                  onClick={() => setWantsSpicyPhotos(false)}
                >
                  <span className="spicy-btn-emoji">🙈</span>
                  <span className="spicy-btn-text">Keep it classy</span>
                </button>
              </div>
            </div>

            <div className="step-nav">
              <button className="btn-ghost" onClick={() => setStep(3)}>Back</button>
              <button className="btn-primary" onClick={() => setStep(5)} disabled={!canContinue()}>Continue</button>
            </div>
          </div>
        )}

        {/* Step 5 - Fantasies */}
        {step === 5 && (
          <div className="step-body">
            <div className="fantasy-section">
              <h3 className="fantasy-title">What are you willing to try?</h3>
              <p className="fantasy-subtitle">You can choose all that excites you</p>

              <div className="fantasy-grid">
                {FANTASY_OPTIONS.map(f => (
                  <button
                    key={f.id}
                    className={`fantasy-btn ${fantasies.includes(f.id) ? 'selected' : ''}`}
                    onClick={() => toggleFantasy(f.id)}
                  >
                    {f.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="step-nav">
              <button className="btn-ghost" onClick={() => setStep(4)}>Back</button>
              <button className="btn-primary" onClick={() => setStep(6)}>Continue</button>
            </div>
          </div>
        )}

        {/* Step 6 - Personality (Libido, Kinkiness, Boldness) */}
        {step === 6 && (
          <div className="step-body">
            <div className="form-field">
              <label>
                Libido: <span className="range-val">{libido}/10</span>
              </label>
              <div className="range-labels"><span>Low</span><span>Insatiable</span></div>
              <input
                type="range"
                min="1"
                max="10"
                value={libido}
                onChange={(e) => setLibido(parseInt(e.target.value))}
              />
            </div>

            <div className="form-field">
              <label>
                Kinkiness: <span className="range-val">{kinkiness}/10</span>
              </label>
              <div className="range-labels"><span>Vanilla</span><span>Kinky</span></div>
              <input
                type="range"
                min="1"
                max="10"
                value={kinkiness}
                onChange={(e) => setKinkiness(parseInt(e.target.value))}
              />
            </div>

            <div className="form-field">
              <label>
                Boldness: <span className="range-val">{boldness}/10</span>
              </label>
              <div className="range-labels"><span>Shy</span><span>Bold</span></div>
              <input
                type="range"
                min="1"
                max="10"
                value={boldness}
                onChange={(e) => setBoldness(parseInt(e.target.value))}
              />
            </div>

            {error && (
              <div style={{ color: '#ff6b6b', fontSize: '13px', padding: '10px', background: 'rgba(255,80,80,0.08)', borderRadius: '8px', border: '1px solid rgba(255,80,80,0.2)', marginBottom: '10px' }}>
                {error}
              </div>
            )}

            <div className="step-nav">
              <button className="btn-ghost" onClick={() => setStep(5)}>Back</button>
              <button className="btn-primary" onClick={handleCreate} disabled={loading}>
                {loading ? 'Creating...' : 'Create your girl'}
              </button>
            </div>
          </div>
        )}

        {/* Step 7 - Voice Messages (Coming Soon) - commented out
        {step === 7 && (
          <div className="step-body">
            <div className="voice-section">
              <div className="voice-icon">🎙️</div>
              <h3 className="voice-title">Would you like to receive voice messages?</h3>
              <div className="coming-soon-badge">COMING SOON</div>
              <p className="voice-subtitle">Voice messages are currently in development. Stay tuned for this exciting feature!</p>
            </div>
            <div className="step-nav">
              <button className="btn-ghost" onClick={() => setStep(6)}>Back</button>
              <button className="btn-primary" onClick={handleCreate} disabled={loading}>
                {loading ? 'Creating...' : 'Create your girl'}
              </button>
            </div>
          </div>
        )}
        */}
      </div>
    </div>
  );
}

export default CharacterCreator;
